import { Input } from 'components/ui/input/input'
import { ChangeEvent, Dispatch, FC, InputHTMLAttributes } from 'react'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  setValue: Dispatch<string>
  suffix?: string
  containerClassName?: string
  hasError?: boolean
  variant?: 'compact' | 'normal' | 'large'
  textEnd?: boolean
}

export const NumberInput: FC<Props> = ({
  name,
  id,
  setValue,
  className = '',
  min = null,
  max = null,
  value,
  variant = 'normal',
  ...props
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === '') {
      setValue(null)
      return
    }

    if (isNaN(Number(`${event.target.value}`))) {
      return
    }

    setValue(event.target.value)
  }

  const handleBlur = (event: ChangeEvent<HTMLInputElement>) => {
    if (min && Number(event.target.value) < Number(min)) {
      setValue(String(min))
    }

    if (max && Number(event.target.value) > Number(max)) {
      setValue(String(max))
    }
  }

  return (
    <Input
      type="number"
      name={name}
      id={id}
      value={value}
      setValue={setValue}
      min={min}
      max={max}
      step="any"
      onChange={handleChange}
      onBlur={handleBlur}
      autoComplete="off"
      autoCorrect="off"
      data-lpignore="true"
      className={className}
      variant={variant}
      {...props}
    />
  )
}
